import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import getShippingPrice from '../../api/shipping.api';
import getProuduct from '../../api/details.api';
import addOrder from '../../api/order.api';
import correct from '../../img/correct-icon.png'
import './Order.css'

const Order = () => {
    const { id, name } = useParams();
    const [productData, setProductData] = useState({})
    let [orderData, setData] = useState({
        product_name: name,
        full_name: '',
        phone_number: '',
        another_phone_number: '',
        city: '',
        address: '',
        quantity: 1
    })
    const [shippingPrice, setShippingPrice] = useState(0)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [loadingOrder, setLoadingOrder] = useState(false)
    const [errorOrder, setErrorOrder] = useState(null)
    const [fullNameError, setFullName] = useState(false)
    const [PhoneNumberError, setPhoneNumber] = useState(false)
    const [cityError, setCity] = useState(false)
    const [colorError, setColorError] = useState(false)
    const [addressError, setAddress] = useState(false)
    const [noCityError, setNoCity] = useState(false)
    const [correctOrder, setCorrectOrder] = useState(false)
    const [notifactionError, setNotiError] = useState(false)
    const [isColor, setIsColor] = useState((name == 'Smart Watch DT100 Plus' || name == 'Smart Watch t55 Plus') ? true : false)
    const [color, setColor] = useState('')

    useEffect(() => {
        getProduct()
    }, [])

    const getProduct = async () => {
        await getProuduct(id, setProductData, setError, setLoading)
    }

    const getShipping = async (type) => {
        await getShippingPrice(type, setShippingPrice)
    }

    const handelInputsChange = (target) => {
        setData({ ...orderData, [target.name]: target.value })
    }

    const sendOrder = () => {
        addOrder(orderData, setErrorOrder, setLoadingOrder, setCorrectOrder)
    }

    const handelVaildation = () => {
        console.log(isColor);
        if (orderData.full_name == '' || orderData.phone_number == '' || orderData.city == '' || orderData.address == '' || ((color == '' || color == 'اختر لون الساعة') && isColor == true)) {
            if (orderData.full_name == '') {
                setFullName(true)
                setNotiError(true)
            }else{
                setFullName(false)
            }
            if (orderData.phone_number == '') {
                setPhoneNumber(true)
                setNotiError(true)
            }else{
                setPhoneNumber(false)
            }
            if (orderData.city == '') {
                setCity(true)
                setNoCity(false)
                setNotiError(true)
            }
            if (orderData.address == '') {
                setAddress(true)
                setNotiError(true)
            }else{
                setAddress(false)
            }
            if((color == '' || color == 'اختر لون الساعة') && isColor == true){
                setColorError(true)
                setNotiError(true)
            }else{
                setColorError(false)
            }
        } else {
            if (shippingPrice == 0) {
                setNoCity(true)
                setCity(false)
                setNotiError(true)
            } else {
                setNotiError(false)
                setFullName(false)
                setPhoneNumber(false)
                setAddress(false)
                setColorError(false)
                setNoCity(false)
                setCity(false)
                sendOrder()
            }
        }
    }

    return (
        <>
            <div className='order-container'>
                <p className="order-title">نموذج طلب اوردر</p>
                <p className='product-name-label'>اسم المنتج</p>
                <p className='order-product-name'>{name}</p>
                <label className='product-name-label'>اسم العميل بالكامل</label>
                <input className='order-input' name='full_name' onChange={(prop) => handelInputsChange(prop.target)} type="text" />
                <p className={`error ${(!fullNameError) ? 'd-none' : 'show-error'}`}>هذا الحقل يجب ان يملأ حتي تتمكن من اتمام عملية الطلب</p>
                <div className='phone-number'>
                    <div>
                        <label className='product-name-label'>رقم المحمول</label>
                        <input className='order-input' name='phone_number' onChange={(prop) => handelInputsChange(prop.target)} type="number" placeholder='01009283744' />
                    </div>
                    <div>
                        <label className='product-name-label'>الرقم البديل <span>(اختياري)</span></label>
                        <input className='order-input' name='another_phone_number' onChange={(prop) => handelInputsChange(prop.target)} type="number" placeholder='يمكنك ادخال رقم ارضي او محمول' />
                    </div>
                </div>
                <p className={`error ${(!PhoneNumberError) ? 'd-none' : 'show-error'}`}>هذا الحقل يجب ان يملأ حتي تتمكن من اتمام عملية الطلب</p>
                <div className="shipping">
                    <div>
                        <label className='product-name-label'>المحافظة</label>
                        <select className='order-input' name='city' onChange={(prop) => { handelInputsChange(prop.target); getShipping(prop.target.value) }}>
                            <option>اختر محافظتك</option>
                            <option>بورسعيد</option>
                            <option>الغربية</option>
                            <option>الدقهلية</option>
                            <option>البحيرة</option>
                            <option>الشرقية</option>
                            <option>كفر الشيخ</option>
                            <option>بني سويف</option>
                            <option>سوهاج</option>
                            <option>الاقصر</option>
                            <option>القاهرة</option>
                            <option>الجيزة</option>
                            <option>الاسكندرية</option>
                            <option>الاسماعيلية</option>
                            <option>سويس</option>
                            <option>القليوبية</option>
                            <option>الفيوم</option>
                            <option>دمياط</option>
                            <option>المنوفية</option>
                            <option>اسيوط</option>
                            <option>قنا</option>
                            <option>اسوان</option>
                            <option>مطروح</option>
                            <option>البحر الاحمر - الغردقة</option>
                            <option>منيا</option>
                        </select>
                    </div>
                    <div>
                        <label className='product-name-label'>مصاريف الشحن</label>
                        <p className='shipping-price'>{(shippingPrice == 0) ? 'تحدد تبعا للمحافظة' : shippingPrice + ' جنيه'}</p>
                    </div>
                </div>
                <p className={`error ${(!cityError) ? 'd-none' : 'show-error'}`}>هذا الحقل يجب ان يملأ حتي تتمكن من اتمام عملية الطلب</p>
                <p className={`error ${(!noCityError) ? 'd-none' : 'show-error'}`}>يجب عليك اختيار محافظتك لكي تتمكن من اتمام عملية الطلب</p>
                <label className={`product-name-label ${(name == 'Smart Watch DT100 Plus') ? null : 'd-none'}`}>لون الساعة المطلوبة</label>
                <select className={`order-input color ${(name == 'Smart Watch DT100 Plus') ? 'd-initial' : 'd-none'}`} onChange={(prop) => { setData({ ...orderData, product_name: name + prop.target.value }); setColor(prop.target.value) }}>
                    <option>اختر لون الساعة</option>
                    <option>الاسود</option>
                    <option>الكحلي</option>
                    <option>الوردي</option>
                </select>
                <label className={`product-name-label ${(name == 'Smart Watch t55 Plus') ? null : 'd-none'}`}>لون الساعة المطلوبة</label>
                <select className={`order-input color ${(name == 'Smart Watch t55 Plus') ? 'd-initial' : 'd-none'}`} onChange={(prop) => { setData({ ...orderData, product_name: name + prop.target.value }); setColor(prop.target.value) }}>
                    <option>اختر لون الساعة</option>
                    <option>الاسود</option>
                    <option>الاحمر</option>
                </select>
                <p className={`error ${(!colorError) ? 'd-none' : 'show-error'}`}>هذاالحقل مطلوب  برجاء اختيار اللون </p>
                <label className='product-name-label'>العنوان بالتفصيل <span>(المنطقة-اسم الشارع-رقم العقار-رقم الشقة)</span></label>
                <input className='order-input' name='address' onChange={(prop) => handelInputsChange(prop.target)} type="text" />
                <p className={`error ${(!addressError) ? 'd-none' : 'show-error'}`}>هذا الحقل يجب ان يملأ حتي تتمكن من اتمام عملية الطلب</p>
                <div className='quantity'>
                    <div>
                        <label className='product-name-label'>الكمية</label>
                        <input className='order-input' name='quantity' onChange={(prop) => { if (prop.target.value == 0) { prop.target.value = 1; handelInputsChange(prop.target) } else { handelInputsChange(prop.target) } }} type="number" defaultValue={orderData.quantity} />
                    </div>
                    <div>
                        <label className='product-name-label'>سعر المنتج</label>
                        <p className='shipping-price'>{productData.product_price}</p>
                    </div>
                </div>
                <label className='product-name-label'>اجمالي السعر المستحق للدفع</label>
                <p className='shipping-price'>{(productData.product_price * orderData.quantity + shippingPrice)} جنيه مصري فقط لا غير</p>
                <button className='order-button' onClick={handelVaildation}>{(loadingOrder) ? <span className="loader-order"></span> : 'تنفيذ الطلب'}</button>
                <p className={`end-error ${(!notifactionError) ? 'd-none' : 'd-block'}`}>عفوا هناك خطأ ما في بيانات الطلب توجه الي الاعلي لمعرفة الخطأ واصلاحة</p>
            </div>
            <div className={`order_layer ${(!correctOrder) ? 'd-none' : 'show-error'}`}>
                <div className="black-layer"></div>
                <div className="order_layer_content">
                    <img src={correct} alt="coorect-icon" />
                    <p>عميلنا العزيز تم تنفيذ الاوردر بنجاح وسيتم التواصل معك من خلال احد ممثلي خدمة العملاء في شركتنا.نتمني لك يوم جيد شكرا لك</p>
                    <Link to={`/details/${id}`}><button>الرجوع لصفحة المنتج</button></Link>
                </div>
            </div>
        </>
    );
}

export default Order;
